import { RootState } from '../index';

export const selectHealthState = (state: RootState) => state.health;
